import makeStyles from '@mui/styles/makeStyles';
import { styled } from "@mui/material/styles";

const styles = makeStyles((_theme) => ({
  containerInputRange: {
    marginTop: "0px !important",
  },
  modalWrapper: {
    maxWidth: "1040px",
  },
}));

export default styles;

export const Wrapper = styled("div")(() => ({
  width: "100%",
}));

export const Title = styled("div")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0.15px",
}));

export const CheckboxContainer = styled("div")(() => ({
  display: "flex",
  height: "64px",
  paddingTop: "24px",
}));
